"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateEmailClassifierConfigAction } from "@/server-actions/email-classifier-config"
import { emailClassifierConfigQueryKey } from "@/hooks/queries/email-classifier-config"
import { withQueryHandling } from "@/lib/with-query-handling"

export function useUpdateEmailClassifierConfigMutation(agentId: string | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: { system_prompt: string; classifier_labels: string[] }) => {
      if (!agentId) throw new Error("Agent ID is required")
      const result = await withQueryHandling(
        updateEmailClassifierConfigAction({ agent_id: agentId, ...input }),
        { loading: "Saving classification settings...", success: "Classification settings saved" },
      )
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: async () => {
      if (agentId) {
        await queryClient.invalidateQueries({ queryKey: emailClassifierConfigQueryKey(agentId) })
      }
    },
  })
}
